export default __webpack_public_path__ + "static/media/second.b407b7f6.png";